export default {"src":"/_next/static/media/user.e17c9a56.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};